var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"promoters-page"}},[_c('LandingBanner'),_c('Simulator'),_c('HowItWorks'),_c('OwnSuccessStories'),_c('Benefits'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }